import { render, staticRenderFns } from "./chemical-list.html?vue&type=template&id=8da59ec8&scoped=true&"
import script from "./chemical-list.js?vue&type=script&lang=js&"
export * from "./chemical-list.js?vue&type=script&lang=js&"
import style0 from "./ChemicalList.vue?vue&type=style&index=0&id=8da59ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da59ec8",
  null
  
)

component.options.__file = "ChemicalList.vue"
export default component.exports